import { render, staticRenderFns } from "./claimbatchSummary.vue?vue&type=template&id=2b8b7155&"
import script from "./claimbatchSummary.vue?vue&type=script&lang=js&"
export * from "./claimbatchSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports